import { FilteredCreditApplication, RequiredDocumentWithStatus } from '@applyonline/shared'
import { scrollToTop } from '@applyonline/shared/utils'
import { EApplicantType } from '@if/core/types'
import WorksheetPage from '../../Worsheet/WorksheetPage'
import { useLayoutEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import ApplicantIncomePage from './components/ApplicantIncomePage'
import CreditSummaryPage from './components/CreditSummaryPage'
import CustomerFeedbackPage from './components/CustomerFeedbackPage'
import DocumentsPage from './components/DocumentsPage'
import IdentityVerificationPage from './components/IdentityVerificationPage'
import OverviewPage from './OverviewPage/OverviewPage'

interface Props {
  creditApp: FilteredCreditApplication
  skipBankAccountRequiredDocuments: RequiredDocumentWithStatus[]
}

const HardHitApprovedResultPage = ({ creditApp, skipBankAccountRequiredDocuments }: Props) => {
  useLayoutEffect(scrollToTop, [])

  return (
    <Routes>
      <Route path="credit-summary" element={<CreditSummaryPage creditApp={creditApp} />} />
      <Route
        path="applicant-incomes"
        element={
          <ApplicantIncomePage
            creditApp={creditApp}
            applicantType={EApplicantType.Applicant}
            skipBankAccountRequiredDocuments={skipBankAccountRequiredDocuments}
          />
        }
      />
      <Route
        path="coapplicant-incomes"
        element={
          <ApplicantIncomePage
            creditApp={creditApp}
            applicantType={EApplicantType.CoApplicant}
            skipBankAccountRequiredDocuments={skipBankAccountRequiredDocuments}
          />
        }
      />
      <Route
        path="applicant-identity-verification"
        element={<IdentityVerificationPage creditApp={creditApp} applicantType={EApplicantType.Applicant} />}
      />
      <Route
        path="coapplicant-identity-verification"
        element={<IdentityVerificationPage creditApp={creditApp} applicantType={EApplicantType.CoApplicant} />}
      />

      <Route path="required-documents" element={<DocumentsPage creditApp={creditApp} />} />

      <Route path="worksheet/:step?" element={<WorksheetPage creditApp={creditApp} />} />

      <Route path="feed-back" element={<CustomerFeedbackPage creditApp={creditApp} />} />

      <Route
        index
        path="*"
        element={
          <OverviewPage creditApp={creditApp} skipBankAccountRequiredDocuments={skipBankAccountRequiredDocuments} />
        }
      />
    </Routes>
  )
}

export default HardHitApprovedResultPage
